import { useTranslation } from 'react-i18next'

import { getEntityProfileTabs } from '../../../Entity'
import { Skeleton } from '../../../Skeleton'
import { TabScrollList } from '../../../Tab'
import { getListingProfileTabsWithAttentionDot } from '../../RentalPortal.utils'
import {
  useApplicantProfileContext,
  useApplicantProfileTabsActiveTab,
} from '../RentalPortalApplicantProfile.hooks'

import {
  APPLICANT_PROFILE_TAB_LIST,
  QA_NAME_APPLICANT_PROFILE_TABS,
} from './RentalPortalApplicantProfileTabs.constants'
import {
  getApplicantProfileTabContent,
  getApplicantProfileTabCounters,
  getApplicantProfileTabsWithComplianceIcon,
  getApplicantProfileTabsWithVisibility,
} from './RentalPortalApplicantProfileTabs.utils'

import * as styles from './RentalPortalApplicantProfileTabs.module.css'

function RentalPortalApplicantProfileTabs() {
  const { t } = useTranslation()

  const { applicantData, applicantId, isInitiated } =
    useApplicantProfileContext()

  const preparedTabs = getListingProfileTabsWithAttentionDot({
    dotClassName: styles.attentionDot,
    preparedTabs: getApplicantProfileTabsWithComplianceIcon({
      iconClassName: styles.tabIcon,
      preparedTabs: getEntityProfileTabs({
        counters: getApplicantProfileTabCounters(applicantData),
        entityData: applicantData,
        t,
        tabs: getApplicantProfileTabsWithVisibility(APPLICANT_PROFILE_TAB_LIST),
      }),
    }),
    tabsAwaitingYou: applicantData?.attention?.tabs_awaiting_you,
    tooltip: t('RentalPortal.ListingProfileTabAwaitingYouTooltipKey'),
  })

  const { activeTabId, handleSetActiveTab } = useApplicantProfileTabsActiveTab({
    applicantData,
    preparedTabs,
  })

  return (
    <>
      {isInitiated ? (
        <TabScrollList
          activeTab={activeTabId}
          preparedTabs={preparedTabs}
          sectionQaName={QA_NAME_APPLICANT_PROFILE_TABS}
          wrapperClassName={styles.tabsWrapper}
          onSetActiveTab={handleSetActiveTab}
        />
      ) : (
        <Skeleton className={styles.skeleton} />
      )}
      {getApplicantProfileTabContent({ activeTabId, applicantId })}
    </>
  )
}

export default RentalPortalApplicantProfileTabs
